import React from 'react';
import {shape_178} from "../../helpers/img";
import {Link} from "react-router-dom";
import {LINK_HOME} from "../../routes/type";
import {withTranslation} from "react-i18next";

const NotFound = ({t}) => {
    return (
        <div>
            <h1>404</h1>
        </div>
    )
}

export default withTranslation()(NotFound)